export class OutletAcquisitionTypeFilter {
    public IncludeInactive?: boolean;
}

export default OutletAcquisitionTypeFilter;